import { callApi } from 'services/api/api'
import { toastStore } from 'stores/toast'
import { TOAST_TYPE } from 'utils/constants'
import { baseURL } from 'services/api/apiConfig'
import { appSelected } from 'stores/navigation'

let selectedApplication = 'physician'
appSelected.subscribe(value => {
  if (value.toLocaleLowerCase() === 'app') {
    selectedApplication = 'app'
  } else {
    selectedApplication = 'physician'
  }
})

/**
 * Delete upload.
 * @param {number} marketDataHeaderKey - The ID of the upload.
 * @returns {Promise<string>} - A promise that resolves to a confirmation message.
 */
export const deleteUpload = async marketDataHeaderKey => {
  try {
    return callApi(`${baseURL}/uploads/${selectedApplication}/market/${marketDataHeaderKey}`, 'DELETE')
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error deleting upload ')
    return ''
  }
}

/**
 * Delete upload org library.
 * @param {number} marketDataHeaderKey - The ID of the upload.
 * @returns {Promise<string>} - A promise that resolves to a confirmation message.
 */
export const deleteOrgLibraryUpload = async marketDataHeaderKey => {
  try {
    return callApi(`${baseURL}/uploads/${selectedApplication}/incumbent/${marketDataHeaderKey}`, 'DELETE')
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error deleting upload org library ')
    return ''
  }
}

/**
 * Send org library upload file
 */

export const postOrgLibraryUpload = async (file, effectiveDate) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('effectiveDate', effectiveDate)

  return new Promise((resolve, reject) => {
    callApi(`${baseURL}/uploads/${selectedApplication}/incumbent`, 'POST', formData)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        if (String(error).includes('Error: 400 -')) {
          reject(String(error).split('Error: 400 -')[1])
        } else {
          reject('There was an error uploading the file')
        }
      })
  })
}

/**
 * Get org library upload file status
 */

export const deleteOrgLibraryStatus = async incumbentDataHeaderKeys => {
  try {
    return await callApi(`${baseURL}/uploads/${selectedApplication}/incumbent`, 'DELETE', incumbentDataHeaderKeys)
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'We couldn`t delete the status of the org library uploads ')
    return {}
  }
}

/**
 * Get org library upload file status
 */

export const getMarketDataStatus = async () => {
  try {
    return await callApi(`${baseURL}/uploads/${selectedApplication}/market`, 'GET')
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'We couldn`t get the status of the market data uploads ')
    return {}
  }
}

/**
 * Get org library upload file status
 */

export const deleteMarketDataStatus = async incumbentDataHeaderKeys => {
  try {
    return await callApi(`${baseURL}/uploads/${selectedApplication}/market`, 'DELETE', incumbentDataHeaderKeys)
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'We couldn`t delete the status of the market uploads ')
    return {}
  }
}

/**
 * Get org library upload file status
 */

export const getOrgLibraryStatus = async () => {
  try {
    return await callApi(`${baseURL}/uploads/${selectedApplication}/incumbent`, 'GET')
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'We couldn`t get the status of the org library uploads ')
    return {}
  }
}

/**
 * Send org library upload file
 */

export const postMarketDataUpload = async (file, effectiveDate, use_faculty_rank_column) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('effectiveDate', effectiveDate)
  formData.append('use_faculty_rank_column', use_faculty_rank_column)

  return new Promise((resolve, reject) => {
    callApi(`${baseURL}/uploads/${selectedApplication}/market`, 'POST', formData)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        if (String(error).includes('Error: 400 -')) {
          reject(String(error).split('Error: 400 -')[1])
        } else {
          reject('There was an error uploading the file')
        }
      })
  })
}
